import React from "react";
import { connect } from "react-redux";

import { getRecentNotices, isNoticesLoading } from "state/teachers/selectors";

import Gate from "components/Gate";
import Preloader from "components/app/home/Preloader";
import Notice from "components/app/home/sections/teachers/Notice";

const NOTICE_COUNT = 3;

class RecentNotices extends React.Component {
  
  renderPlaceholder() {
    return (
      <div className="teachers-home-notices__placeholder">
        There are currently no notices to display.
      </div>
    )
  }
  
  render() {
    return (
      <div className="home-section teachers-home-notices">
        <div className="home-section-heading home-section-heading--teachers teachers-home-notices__heading">Recent Notices</div>
        <Preloader isLoading={this.props.isLoading}>
          <Gate isOpen={this.props.notices.size > 0} placeholder={this.renderPlaceholder()}>
            <div className="teachers-home-notices__body">
              {
                this.props.notices.map(notice => (
                  <Notice key={notice.get("id")} notice={notice} />
                ))
              }
            </div>
          </Gate>
        </Preloader>
      </div>
    )
  }
  
}

export default connect(
  state => ({
    notices: getRecentNotices(state, NOTICE_COUNT),
    isLoading: isNoticesLoading(state)
  })
)(RecentNotices);



// WEBPACK FOOTER //
// ./src/components/app/home/sections/teachers/RecentNotices.js